export default "__VITE_ASSET__7c29051d__"